module.exports = __webpack_public_path__ + "4c96e7e2d2e8e91c24f3baacc56d224f.png";